import {createAsyncThunk} from '@reduxjs/toolkit';
import api from 'services/axios';

export const getTrackings = createAsyncThunk<any, any>(
  'tracking/getTrackings',
  async (params, thunkApi) => {
    try {
      const response = await api.get(`/dasht/ticketing/ticket`, {
        params,
        paramsSerializer: {
          indexes: null
        },
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getTracking = createAsyncThunk<any, any>(
  'tracking/getTracking',
  async (params, thunkApi) => {
    try {
      const response = await api.get(
        `/dasht/ticketing/ticket/${params.tracking_id}?vendor_id=${params.vendor_id}`,
        {
          goBaseUrl: true
        }
      );
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const addTrackingComment = createAsyncThunk<any, any>(
  'tracking/addTrackingComment',
  async (data, thunkApi) => {
    try {
      const response = await api.post(
        `/dasht/ticketing/ticket/${data.tracking_id}/comment?vendor_id=${data.vendor_id}`,
        data,
        {
          goBaseUrl: true
        }
      );
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const uploadFiles = createAsyncThunk<any, any>(
  'tracking/uploadFiles',
  async (data, thunkApi) => {
    try {
      const response = await api.post(
        `/dasht/ticketing/attachment?vendor_id=${data.id}`,
        data.file,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          goBaseUrl: true
        }
      );
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e || 'خطا در آپلود');
    }
  }
);

export const downloadAttachment = createAsyncThunk<any, any>(
  'tracking/downloadAttachment',
  async (params, thunkApi) => {
    try {
      const response = await api.get(
        `/dasht/ticketing/attachment/${params.id}?vendor_id=${params.vendor_id}`,
        {
          goBaseUrl: true,
          responseType: 'blob'
        }
      );
      return thunkApi.fulfillWithValue({data: response.data, headers: response.headers});
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);
